import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import Copy from '../Common/Copy';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import Pagination from '../Common/Pagination';


export default function Pools() {
    const { togel, formatAddress, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime, pdata } = useContext(GMCContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pages, setPages] = useState(1);
    const [data, setData] = useState([]);
    //  const [pdata, setpData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const onButtonClick = () => {
        Swal.fire({
            title: '💰 <span style="color:#4f46e5;">Create Pool Amount</span>',
            html: `
      <div style="text-align:left; font-family:'Poppins', sans-serif;">
        <label style="font-weight:600; color:#374151;">Enter Amount ($)</label>
        <input id="swal-amount" type="number" min="0" step="0.01"
               class="swal2-input swal-input-custom" placeholder="Enter amount" />

        <div id="swal-rewards" style="margin-top:20px; padding:12px; border-radius:10px; background:#f3f4f6; font-size:15px; line-height:1.6; color:#111827;">
          <p style="color:#6b7280; text-align:center;">Enter amount to see rewards...</p>
        </div>
      </div>
    `,
            focusConfirm: false,
            showCancelButton: true,
            background: "#ffffff",
            color: "#111827",
            confirmButtonText: "Add",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#6366f1",
            cancelButtonColor: "#ef4444",
            customClass: {
                popup: "swal-popup-custom",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            },
            preConfirm: () => {
                const amount = Number(document.getElementById("swal-amount").value);
                if (!amount || amount <= 0) {
                    Swal.showValidationMessage("⚠️ Please enter a valid amount");
                    return false;
                }
                return { amount };
            },
            didOpen: () => {
                const amountInput = document.getElementById("swal-amount");
                const rewardsDiv = document.getElementById("swal-rewards");

                function updateRewards() {
                    const amount = Number(amountInput.value) || 0;

                    if (!amount) {
                        rewardsDiv.innerHTML = `<p style="color:#6b7280; text-align:center;">Enter amount to see rewards...</p>`;
                        return;
                    }

                    // Build reward list with card-like styling
                    rewardsDiv.innerHTML = `
          <h4 style="margin-bottom:12px; font-weight:600; color:#374151;">Calculated Rewards</h4>
          <div style="display:grid; gap:8px;">
            ${pdata
                            .map(
                                (pool, idx) => `
                  <div style="background:#fff; padding:10px 14px; border-radius:8px; box-shadow:0 2px 8px rgba(0,0,0,0.05); display:flex; justify-content:space-between; align-items:center;">
                    <span style="font-weight:500; color:#4f46e5;">${pool.name ?? `Pool ${idx + 1}`}</span>
                    <span style="font-weight:600; color:#111827;">$${(
                                        (amount * pool.per) /
                                        100
                                    ).toFixed(2)} <small style="color:#6b7280;">(${pool.per}%)</small></span>
                  </div>`
                            )
                            .join("")}
          </div>
        `;
                }

                // Update when amount changes
                amountInput.addEventListener("input", updateRewards);
            },
        }).then((result) => {
            if (result.isConfirmed) {
                const { amount } = result.value;
                console.log("Entered Amount:", amount);
                handleBlockChange(true, amount);
            }
        });
    };


    // const onButtonClick = () => {
    //     Swal.fire({
    //         title: '💰 Create Pool Amount',
    //         input: 'number',
    //         inputLabel: 'Enter amount',
    //         inputPlaceholder: 'Enter amount in $',
    //         inputAttributes: {
    //             min: 0,
    //             step: 0.01
    //         },
    //         background: '#f9fafb', // light background
    //         color: '#111827',      // dark text
    //         icon: 'info',
    //         iconColor: '#4f46e5',  // indigo accent
    //         showCancelButton: true,
    //         confirmButtonColor: '#6366f1', // indigo button
    //         cancelButtonColor: '#ef4444',  // red cancel
    //         confirmButtonText: '<i class="fas fa-check-circle"></i> Yes, Add!',
    //         cancelButtonText: '<i class="fas fa-times"></i> Cancel',
    //         customClass: {
    //             popup: 'swal-popup-custom',
    //             input: 'swal-input-custom',
    //             confirmButton: 'swal-confirm-btn',
    //             cancelButton: 'swal-cancel-btn'
    //         },
    //         preConfirm: (value) => {
    //             if (!value || isNaN(value) || Number(value) <= 0) {
    //                 Swal.showValidationMessage('⚠️ Please enter a valid amount');
    //                 return false;
    //             }
    //             return Number(value);
    //         }
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             const enteredAmount = result.value;

    //             console.log('setpoolData',pdata)
    //             handleBlockChange(true, enteredAmount);
    //             //  let reward = (enteredAmount * allpool[i - 1].per) / 100; // Calculate reward percentage
    //         }
    //     });
    // };


    const handleBlockChange = async (isChecked, amount) => {
        try {
            // console.log('isChecked', isChecked, 'amount', amount);
            setLoading(true); // show loader
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "trade",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                amount: amount
            });

            if (res.data?.resCode === 200) {
                await getData(); // refresh table
            } else {
                console.error("Unexpected response:", res.data);
            }
        } catch (err) {
            setLoading(false); // hide loader
            console.error("Error sending block data:", err);
        }
    };

    useEffect(() => {
        getData();
    }, [pageSize, currentPage]);


    // Fetch data function
    const getData = async () => {
        try {
            setLoading(true);
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "achivepoolinc",
                submethod: "get",
                key: process.env.REACT_APP_KEY,
                search: search,
                page: currentPage,
                pageSize: pageSize,

            });

            setLoading(false);
            // console.log('res.data.data', res.data.data)
            if (res.data.error) return;
            setData(res.data.data);
            setPages(Math.ceil(res.data.total / pageSize));
            // console.log('Math.ceil(res.data.totalPages / pageSize)', Math.ceil(res.data.total / pageSize));

        } catch (err) {
            console.log("Error : ", err);
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, [pageSize, currentPage]);

    useEffect(() => {
        if (currentPage > pages) {
            setCurrentPage(1); // Reset to page 1 if currentPage is out of range
        }
    }, [pages, search]);

    return (
        <>
            <Header />
            <Sidebar />
            {loading && (

                <div className="loader-overlay">
                    <div className="big-spinner" role="status" aria-label="Loading"></div>
                </div>

            )}

            <div id="layout-wrapper">
                <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* Page Title Section */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                            <li className="breadcrumb-item active">Pool Reward</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            {/* Member Report Table Section */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">Pool Reward</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="listjs-table" id="customerList">
                                                {/* Table Action Buttons */}
                                                <div className="row g-4 mb-3">
                                                    <div className="col-sm-auto">

                                                    </div>
                                                    <div className="col-sm">
                                                        <div className="d-flex justify-content-sm-end">
                                                            <button className="custom-btn" onClick={onButtonClick}>
                                                                Add Amount
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Table */}
                                                <div className="table-responsive table-card mt-3 mb-1">
                                                    <table className="table align-middle table-nowrap" id="customerTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="gridjs-th text-center">#</th>
                                                                <th className="gridjs-th text-center">Amount</th>
                                                                <th className="gridjs-th text-center">Users</th>
                                                                <th className="gridjs-th text-center">Reward</th>
                                                                <th className="gridjs-th text-center">RewardPerUser</th>
                                                                <th className="gridjs-th text-center">Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data.length > 0 ? (
                                                                data.map((ele, i) => {
                                                                    const index = currentPage * pageSize - pageSize + (i + 1);
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td className="gridjs-td text-center">{index}</td>
                                                                            <td className="gridjs-td text-center">$ {ele.amount || "0"}</td>
                                                                            <td className="gridjs-td text-center">
                                                                                <strong>NetWork1</strong> <br />
                                                                                {ele.network1user.length} <br />
                                                                                <strong>NetWork2</strong> <br />
                                                                                {ele.network2user.length} <br />
                                                                                <strong>NetWork3</strong> <br />
                                                                                {ele.network3user.length} <br />
                                                                                <strong>NetWork4</strong> <br />
                                                                                {ele.network4user.length}
                                                                            </td>
                                                                            <td className="gridjs-td text-center">
                                                                                <strong>NetWork1</strong> <br />
                                                                                $ {ele.network1reward} <br />
                                                                                <strong>NetWork2</strong> <br />
                                                                                $ {ele.network1reward} <br />
                                                                                <strong>NetWork3</strong> <br />
                                                                                $ {ele.network1reward} <br />
                                                                                <strong>NetWork4</strong> <br />
                                                                                $ {ele.network1reward}</td>
                                                                            <td className="gridjs-td text-center">
                                                                                <strong>NetWork1</strong> <br />
                                                                                $ {(ele.network1peruser) ? (ele.network1peruser).toFixed(2) : 0} <br />
                                                                                <strong>NetWork2</strong> <br />
                                                                                $ {(ele.network2peruser) ? (ele.network2peruser).toFixed(2) : 0} <br />
                                                                                <strong>NetWork3</strong> <br />
                                                                                $ {(ele.network3peruser) ? (ele.network3peruser).toFixed(2) : 0} <br />
                                                                                <strong>NetWork4</strong> <br />
                                                                                $ {(ele.network4peruser) ? (ele.network4peruser).toFixed(2) : 0}
                                                                            </td>
                                                                            <td className="gridjs-td text-center">{formatDateTime(ele.date)}</td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="11" className="text-center">
                                                                        No data available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                    <style>
                                                        {`
                                                        .custom-btn {
                                                            background: linear-gradient(135deg, #405189, #6366f1); /* Indigo gradient */
                                                            color: #fff;
                                                            font-size: 16px;
                                                            font-weight: 600;
                                                            padding: 12px 32px;
                                                            border: none;
                                                            border-radius: 50px; /* pill shape */
                                                            cursor: pointer;
                                                            box-shadow: 0 6px 18px rgba(79, 70, 229, 0.4);
                                                            transition: all 0.3s ease;
                                                            letter-spacing: 0.5px;
                                                            position: relative;
                                                            overflow: hidden;
                                                        }

                                                        /* Shine animation effect */
                                                        .custom-btn::before {
                                                            content: "";
                                                            position: absolute;
                                                            top: 0;
                                                            left: -75px;
                                                            width: 50px;
                                                            height: 100%;
                                                            background: rgba(255, 255, 255, 0.4);
                                                            transform: skewX(-25deg);
                                                            transition: left 0.5s;
                                                        }

                                                        .custom-btn:hover::before {
                                                            left: 125%;
                                                        }

                                                        /* Hover */
                                                        .custom-btn:hover {
                                                            background: linear-gradient(135deg, #6366f1, #2a20e7ff);
                                                            transform: translateY(-3px);
                                                            box-shadow: 0 8px 22px rgba(79, 70, 229, 0.6);
                                                        }

                                                        /* Active/Click */
                                                        .custom-btn:active {
                                                            transform: scale(0.96);
                                                            box-shadow: 0 4px 12px rgba(79, 70, 229, 0.5);
                                                        }

                                                        /* Popup box */
                                                        .swal-popup-custom {
                                                            border-radius: 16px !important;
                                                            padding: 20px !important;                 
                                                            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
                                                            font-family: 'Poppins', sans-serif;
                                                        }

                                                        /* Input box */
                                                        .swal-input-custom {
                                                            border-radius: 10px !important;
                                                            border: 1px solid #d1d5db !important;
                                                            padding: 10px !important;
                                                            font-size: 16px !important;
                                                            text-align: center;
                                                        }

                                                        /* Confirm button */    
                                                        .swal-confirm-btn {
                                                            background: linear-gradient(135deg, #6366f1, #3b82f6) !important;
                                                            color: #fff !important;
                                                            border-radius: 12px !important;
                                                            font-weight: 600 !important;
                                                            padding: 10px 20px !important;
                                                            transition: transform 0.2s ease;
                                                        }
                                                        .swal-confirm-btn:hover {
                                                            transform: scale(1.05);
                                                        }

                                                        /* Cancel button */
                                                        .swal-cancel-btn {
                                                            background: #ef4444 !important;
                                                            color: #fff !important;
                                                            border-radius: 12px !important;
                                                            font-weight: 600 !important;
                                                            padding: 10px 20px !important;
                                                            transition: transform 0.2s ease;
                                                        }
                                                        .swal-cancel-btn:hover {
                                                            transform: scale(1.05);   
                                                        }   

                                                        `}
                                                    </style>
                                                </div>

                                                <Pagination
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    pages={pages}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}